import React from "react";

import FacebookSvg from "images/icons/facebook-dark.inline.svg";
import LinkedINSvg from "images/icons/linkedin-dark.inline.svg";
import InstagramPureSvg from "images/icons/instagram-pure.inline.svg";
import WhatsAppSvg from "images/icons/whatsapp-dark.inline.svg";

export const shareIcons = (shareUrl, shareText = "") => {
  return [
    {
      node: (
        <div className="">
          <a
            rel="noreferrer noopener"
            target="_blank"
            href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
            className="no-underline"
          >
            <FacebookSvg className="w-6 fill-gray-lighter hover:fill-[#1877F2]" />
          </a>
        </div>
      ),
      type: "component"
    },
    // {
    //   node: (
    //     <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-lighter hover:bg-white">
    //       <a
    //         rel="noreferrer noopener"
    //         target="_blank"
    //         href={`https://www.instagram.com/sharer.php?u=${shareUrl}`}
    //         className="no-underline"
    //       >
    //         <InstagramPureSvg
    //           className="p-1 hover:!filter-none"
    //           style={{ filter: "grayscale(100%) brightness(0) invert(1)" }}
    //         />
    //       </a>
    //     </div>
    //   ),
    //   type: "component"
    // },
    {
      node: (
        <div className="">
          <a
            rel="noreferrer noopener"
            target="_blank"
            href={`https://linkedin.com/shareArticle?url=${shareUrl}`}
            className="no-underline"
          >
            <LinkedINSvg className="w-6 fill-gray-lighter hover:fill-[#0077B5]" />
          </a>
        </div>
      ),
      type: "component"
    },
    {
      node: (
        <div className="">
          <a
            rel="noreferrer noopener"
            target="_blank"
            href={`https://api.whatsapp.com/send?text=${shareText}${shareUrl}`}
            className="no-underline"
          >
            <WhatsAppSvg className="w-6 fill-gray-lighter hover:fill-[#25D366]" />
          </a>
        </div>
      ),
      type: "component"
    }
  ];
};
